module.exports = __webpack_public_path__ + "img/logo.ccecd555.png";